/**
 * Module to take care of the API calls and Model of reporting and schedules features.
 */
define('dataSource/reporting/reportingPdfDownload',['knockout', 'jquery', 'lodash', 'atn/atn', 'dataSource/apiCallPollingInterface',
    'dataSource/reporting/reporting' ],
    function(ko, $, _, atn, apiCallPollingInterface, reportingDataSource) {
        'use strict';

        /**
         * The polling object used to maintain the state and functioning 
         * of the generate PDF now function. 
         */

        var reportPollCodes = {
            DONE: 'SUCCESSFUL',
            FAILED: 'FAILED',
            POLLING: 'IN_PROGRESS'
        };


        var cachedObj = {};


        var reportIdPollStatusMap = ko.computed(function(){
            
            _.forEach(reportingDataSource.reportsList(),function(report){
                if(!cachedObj[report.reportScheduleId()]){
                    cachedObj[report.reportScheduleId()] = {};
                    cachedObj[report.reportScheduleId()].pollStatus = ko.observable(reportPollCodes.DONE);
                    cachedObj[report.reportScheduleId()].name = report.name();
                }    
            });
            return cachedObj;
        });
        
        atn.dataCache.addRegistry(reportIdPollStatusMap);

        return {
            reportIdPollStatusMap: reportIdPollStatusMap,
            downloadPdfReport: downloadPdfReport,
            reportPollCodes: reportPollCodes
        };

        /**
         * [downloadPdfReport start the process to download the report]
         * @param  {Number} reportId [the id of the report to be generated]
         * @return {Deferred promise} [a deferred promise to download the report]
         */
        function downloadPdfReport(reportId, windowOpenCallback){
            var deferred = $.Deferred();
            var promise = triggerDownloadPdfRequest(reportId);
            reportIdPollStatusMap()[reportId].pollStatus(reportPollCodes.POLLING);
            promise.done(function(requestId){
                /**
                 * Once the download report request is made, start polling to check when the report will be completed.
                 */
                startPdfGenerationPolling(reportId, requestId, windowOpenCallback);
                deferred.resolve();
            });

            promise.fail(function(xhr){
                deferred.reject();
            });

            return deferred.promise();
        }

        /**
         * [triggerDownloadPdfRequest Makes teh initial request to the API to start creating the report given the reportId]
         * @param  {Number} reportId [the id of the report to be generated]
         * @return {Deferred promise} [a deferred promise to start the download process]
         */
        function triggerDownloadPdfRequest(reportId){
            var deferred = $.Deferred(),
                pdfGenerationAjaxSettings = {
                    url: atn.config.api.reports + '/' + reportId + '/generationRequests',
                    type: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify({}),
                    global: false
                },
                promise = $.ajax(pdfGenerationAjaxSettings);


            promise.done(function(response) {
                /**
                 * delete the corresponding report from the grid data
                 */
                deferred.resolve(response.requestId);
            });
            promise.fail(function() {
                deferred.reject();
            });
            return deferred.promise();
        }

        /**
         * [startPdfGenerationPolling starts polling for the report given the reportId and requestId for pdf's for the report.]
         * @param  {Number} reportId [the id of the report to be generated]
         * @param  {Number} requestId [if multiple requests are made for the report, multiple requestIds are generated]
         * @return {undefined}
         */
        function startPdfGenerationPolling(reportId, requestId, windowOpenCallback){
            var pdfPollAjaxSettings = {
                url: atn.config.api.reports + '/' + reportId + '/generationRequests/' + requestId,
                type: 'GET',
                dataType: 'json',
                global: false
            };

            var pdfPollingContext = {
                reportId: reportId,
                requestId: requestId,
                onDoneCb: windowOpenCallback
            };
            
            var pdfPollingInterval = 20;

            if(!(reportIdPollStatusMap()[reportId].pollerObj)){
                reportIdPollStatusMap()[reportId].pollStatus(reportPollCodes.POLLING);  
                reportIdPollStatusMap()[reportId].pollerObj = apiCallPollingInterface.createPolling(
                    pdfGenerationPollFail, 
                    pdfGenerationPollSuccess,
                    pdfPollAjaxSettings, 
                    pdfPollingInterval,
                    pdfPollingContext);

                reportIdPollStatusMap()[reportId].pollerObj.start();
            }

        }

        /**
         * [pdfGenerationPollSuccess Success callback for the polling for the report pdf download]
         * @param  {Object} response          [the response of the polling success operation]
         * @param  {Object} pdfPollingContext [the current polling context]
         * @return {undefined}
         */
        function pdfGenerationPollSuccess(response, pdfPollingContext) {
            //response and some property of teh response which tell to stop polling
            var reportId = pdfPollingContext.reportId;
            if(response.reportGenerationStatus === reportPollCodes.DONE && pdfPollingContext){
                reportIdPollStatusMap()[reportId].pollerObj.stop();

                reportIdPollStatusMap()[reportId].pollStatus(reportPollCodes.SUCCESSFUL);
                atn.toasterRegistry.addToasterMessage(atn.utils.sformat(atn.config.messages.reporting.pdfGenerationSuccess, reportIdPollStatusMap()[reportId].name));
                pdfPollingContext.onDoneCb(response.reportUrl);
                delete reportIdPollStatusMap()[reportId].pollerObj;
                //delete on report download triggered.
            }

            if(response.reportGenerationStatus === reportPollCodes.FAILED){
                reportIdPollStatusMap()[reportId].pollerObj.stop();
                reportIdPollStatusMap()[reportId].pollStatus(reportPollCodes.FAILED);
                atn.toasterRegistry.addToasterMessage(atn.utils.sformat(atn.config.messages.reporting.pdfGenerationFailed, reportIdPollStatusMap()[reportId].name));
                delete reportIdPollStatusMap()[reportId].pollerObj;
            }

        }

        /**
         * [pdfGenerationPollFail Failure callback for the polling for the report pdf download]
         * @param  {Object} xhr               [the pollling error response]
         * @param  {Object} pdfPollingContext [the current polling context]
         * @return {undefined}
         */
        function pdfGenerationPollFail(xhr, pdfPollingContext) {
            var reportId = pdfPollingContext.reportId;
            //  stopping loading
            reportIdPollStatusMap()[reportId].pollerObj.stop();
            reportIdPollStatusMap()[reportId].pollStatus(reportPollCodes.FAILED);
            delete reportIdPollStatusMap()[reportId].pollerObj;
            atn.toasterRegistry.addToasterMessage(atn.utils.sformat(atn.config.messages.reporting.pdfGenerationFailed, reportIdPollStatusMap()[reportId].name));
        }

    });
